import axios from "axios";
import { baseUrl } from "../../Config/baseUrl";

export const GetAdminUserProfile = async (req) => {
  try {
    const response = await axios.get(`${baseUrl}/blog/admin-user-profile/`, {
      params: req,
      headers: {
        Authorization: `Token ${localStorage.getItem("token")}`,
      },
    });
    return response;
  } catch (err) {
    throw new Error(err);
  }
};

export const AddUser = async (req) => {
  try {
    const response = await axios.post(
      `${baseUrl}/blog/admin-user-profile/`,
      req,
      {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      },
    );
    return response;
  } catch (err) {
    throw new Error(err);
  }
};

export const DeleteUser = async (req) => {
  try {
    const response = await axios.delete(`${baseUrl}/blog/admin-user-profile/`, {
      data: req,
      headers: {
        Authorization: `Token ${localStorage.getItem("token")}`,
      },
    });
    return response;
  } catch (err) {
    throw err;
  }
};

export const PostAdminUserProfile = async (reqbody) => {
  try {
    const response = await axios.post(
      `${baseUrl}/blog/admin-user-Profile-enable-disable-api/`,
      reqbody,
      {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      },
    );
    return response;
  } catch (err) {
    throw new Error(err);
  }
};
